<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon
          slot="icon-only"
          name="close"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="edit-guest-content ion-padding">
  <div class="edit-guest-shell">
    <p
      class="edit-guest-message"
      *ngIf="message"
    >
      {{ message }}
    </p>
    <div class="card-shell">
      <div class="card-title-row">
        <div class="card-title">{{ cardTitle }}</div>
      </div>
      <div class="search-row">
        <ion-input
          class="form-input"
          type="text"
          [placeholder]="placeholder"
          [(ngModel)]="name"
          (keyup.enter)="search()"
        ></ion-input>
        <ion-button
          class="search-action-btn"
          fill="solid"
          color="secondary"
          [disabled]="!name?.trim()"
          (click)="search()"
        >
          Search
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>
